module.exports = __webpack_public_path__ + "img/tiktok_white.a98780fd.svg";